import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { SOLUTION_LINKS } from "../pages/solutions/links";

// Public "For Employers" mega-menu (logged-out visitors). A wide panel of the
// six employer solution pages, driven by the single source of truth in
// pages/solutions/links.js.
export default function EmployersMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onClick); document.removeEventListener("keydown", onKey); };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 text-sm font-medium hover:text-[#1D4ED8] transition-colors"
        aria-expanded={open}
        data-testid="nav-employers"
      >
        For Employers
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-3 w-[620px] max-w-[calc(100vw-2rem)] bg-white border border-border rounded-2xl shadow-xl shadow-[#0F172A]/10 p-3 z-50">
          <div className="grid grid-cols-2 gap-1.5">
            {SOLUTION_LINKS.map((f) => (
              <Link
                key={f.key}
                to={f.to}
                onClick={() => setOpen(false)}
                className="group flex items-start gap-3 rounded-xl p-3 hover:bg-secondary transition-colors"
              >
                <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: `${f.accent}14`, color: f.accent }}>
                  <f.icon className="w-[18px] h-[18px]" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-[#0F172A] group-hover:text-[#0025D8] transition-colors">{f.label}</div>
                  <div className="text-xs text-muted-foreground leading-snug">{f.desc}</div>
                </div>
              </Link>
            ))}
          </div>
          <Link
            to="/signup?role=company"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-between gap-2 rounded-xl border border-dashed border-border px-3.5 py-2.5 hover:border-[#0025D8]/40 hover:bg-[#0025D8]/5 transition-colors"
          >
            <span className="text-xs text-muted-foreground">Screen candidates with AI — free to start.</span>
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#0025D8]">Get started <ArrowRight className="w-3.5 h-3.5" /></span>
          </Link>
        </div>
      )}
    </div>
  );
}
